module.exports = __webpack_public_path__ + "img/menu-calculate.79be7213.svg";